import {createAction, props} from "@ngrx/store";
import {ActionType} from "@/main/autoreg/registration/store/action.type";
import {AutoRegItemType} from "@/main/autoreg/accounts/store/type/autoRegItem.type";

export const getAutoRegsAction = createAction(
  ActionType.GET_AUTOREGS,
  props<{autoregs: AutoRegItemType[]}>()
)
